// extracted by mini-css-extract-plugin
export default {"HelloApi":"HelloApi_HelloApi__svJRn","Content":"HelloApi_Content__An6C+","Icone":"HelloApi_Icone__Tbzjk","Textes":"HelloApi_Textes__44G35"};